import React from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import buttonBackground from "../assets/button_background_blue.webp";

// Type definitions
interface WatcherFormSubmittedProps {
  setFormState: (state: number) => void;
  clearData: () => void;
  isEditMode?: boolean;
}

const WatcherFormSubmitted: React.FC<WatcherFormSubmittedProps> = ({
  setFormState,
  clearData,
  isEditMode = false,
}) => {
  const navigate = useNavigate();

  const backToStart = (): void => {
    clearData();
    setFormState(1);
    if (isEditMode) {
      navigate("/rule/create");
    }
  };

  const handleNavigateToWatcherList = (): void => {
    navigate("/rules");
  };

  return (
    <div style={{ marginTop: 10, padding: "0 10px" }}>
      <div
        className="center_me"
        style={{
          marginTop: 10,
        }}
      >
        <div
          className="row  center_me border_radius"
          style={{
            width: 350,
          }}
        >
          <div className="center_me ">
            <h2
              className="font_family_base text_green"
              style={{
                fontSize: 24,
                fontWeight: "bold",
                marginBottom: 10,
                textAlign: "center",
                // color: "#FFF",
                marginTop: 10,
                width: 300,
              }}
            >
              Rule Saved
            </h2>
          </div>
          <div className="center_me row">
            <button
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                marginTop: "5px",
                marginBottom: "5px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
              onClick={handleNavigateToWatcherList}
            >
              Go to Rules Page
            </button>
            {/* <button
              className="my-form-button-wide font_family_base"
              onClick={handleNavigateToWatcherList}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                marginTop: 10,
                width: 300,
              }}
            >
              <span
                className="font_family_base"
                style={{
                  color: "#007AFF",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                Go to Rules Page
              </span>
            </button> */}
          </div>
          <div
            className="center_me row"
            style={{ marginBottom: 20, marginTop: 20 }}
          >
            <button
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                marginTop: "5px",
                marginBottom: "5px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
              onClick={backToStart}
            >
              Create Another Rule
            </button>
            {/* <button
              className="my-form-button-wide font_family_base"
              onClick={backToStart}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                marginTop: 10,
                marginBottom: 20,
                width: 300,
              }}
            >
              <span
                className="font_family_base"
                style={{
                  color: "#007AFF",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                Create Another Rule
              </span>
            </button> */}
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default WatcherFormSubmitted;
